import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  headerContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& + table': {
      marginTop: 0,
    },
  },
  error: {
    display: 'block',
    marginLeft: theme.spacing(1),
    color: theme.palette.error.main,
  },
  emptyData: {
    '& > *': {
      textAlign: 'center',
    },
  },
  sortIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  progress: {
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    zIndex: 10,
  },
  progressContainer: {
    border: 'none',
    position: 'relative',
  },
}));
